var dropdown = {
  'old-skin': {
    collapse: {
      borderRadius: '4px',
      top: 'calc(100% + 4px)',
      padding: '6px',
      minWidth: '200px'
    },
    menu: {
      mobile: {
        padding: '0 16px'
      },
      desktop: {
        padding: '0'
      }
    },
    items: {
      overflow: 'visible'
    },
    link: {
      borderRadius: '4px',
      marginBottom: '0px',
      padding: '0px 6px',
      mobile: {
        fontSize: '14px',
        lineHeight: '40px',
        fontWeight: '600'
      },
      desktop: {
        fontSize: '16px',
        lineHeight: '32px',
        fontWeight: 'normal'
      }
    },
    divider: {
      mobile: {
        margin: '6px -16px'
      },
      desktop: {
        margin: '6px -6px'
      }
    }
  },
  medium: {
    collapse: {
      borderRadius: '8px',
      top: 'calc(100% + 4px)',
      padding: '8px',
      minWidth: '312px'
    },
    menu: {
      mobile: {
        padding: '8px'
      },
      desktop: {
        padding: '0px'
      }
    },
    items: {
      overflow: 'hidden'
    },
    link: {
      borderRadius: '8px',
      marginBottom: '8px',
      padding: '0px 16px',
      mobile: {
        fontSize: '14px',
        lineHeight: '36px',
        fontWeight: 'bold'
      },
      desktop: {
        fontSize: '14px',
        lineHeight: '36px',
        fontWeight: 'bold'
      }
    },
    divider: {
      mobile: {
        margin: '5px 0'
      },
      desktop: {
        margin: '5px 0'
      }
    }
  },
  'new-skin': {
    collapse: {
      borderRadius: '16px',
      top: '0px',
      padding: '16px 16px 20px',
      minWidth: '320px'
    },
    menu: {
      mobile: {
        padding: '18px 16px'
      },
      desktop: {
        padding: '0'
      }
    },
    items: {
      overflow: 'auto'
    },
    link: {
      borderRadius: '8px',
      marginBottom: '8px',
      padding: '0px 16px',
      mobile: {
        fontSize: '18px',
        lineHeight: '48px',
        fontWeight: 'normal'
      },
      desktop: {
        fontSize: '18px',
        lineHeight: '48px',
        fontWeight: 'normal'
      }
    },
    divider: {
      mobile: {
        margin: '5px 0'
      },
      desktop: {
        margin: '5px 0'
      }
    }
  },
  small: {
    collapse: {
      borderRadius: '8px',
      top: 'calc(100% + 4px)',
      padding: '8px',
      minWidth: '246px'
    },
    menu: {
      mobile: {
        padding: '8px'
      },
      desktop: {
        padding: '0px'
      }
    },
    items: {
      overflow: 'hidden'
    },
    link: {
      borderRadius: '8px',
      padding: '8px 12px',
      mobile: {
        fontSize: '14px',
        lineHeight: '20px'
      },
      desktop: {
        fontSize: '14px',
        lineHeight: '20px'
      }
    },
    divider: {
      mobile: {
        margin: '5px 0'
      },
      desktop: {
        margin: '5px 0'
      }
    }
  }
};
export default dropdown;